// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickTable_wrap__N06Wr {
  --heightTransitionForward: 1s;
  --heightTransitionBackward: 0.5s;
  --borderRadius: 0.5em;
  position: relative;
  border-radius: var(--borderRadius);
  background: var(--foreground-color-1);
  box-shadow: 1px 1px 5px var(--foreground-color-1-alpha);
}
.ClickTable_wrap__N06Wr .ClickTable_log__W\\+AMo {
  position: absolute;
  height: 1px;
  width: 1px;
  clip: rect(0 0 0 0);
  overflow: hidden;
  white-space: nowrap;
}
.ClickTable_wrap__N06Wr .ClickTable_staticRow__L\\+O0r {
  min-height: 5em;
  width: 100%;
  background: var(--background-color-1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5em;
}
.ClickTable_wrap__N06Wr .ClickTable_staticRow__L\\+O0r .ClickTable_loadingIcon__i50MF {
  font-size: 2em;
  color: var(--lightblue);
}
.ClickTable_wrap__N06Wr .ClickTable_scrollbarTrack__shH-1 {
  left: 0;
  right: 0;
  z-index: 1;
}
.ClickTable_wrap__N06Wr .ClickTable_scrollbarThumb__nhUye {
  background: var(--foreground-color-1-alpha);
  border-radius: 100px;
  top: -0.5em;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo {
  width: 100%;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup]:last-of-type {
  background: var(--background-color-1);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] {
  display: flex;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row]:not(:last-of-type) [role=gridcell] {
  border-bottom: 1px solid var(--lightgray);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row]:not(:last-of-type) [role=gridcell].ClickTable_pressed__No4oW {
  border-bottom: 1px solid transparent;
  border-right: 1px solid var(--lightgray);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell],
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=columnheader] {
  position: relative;
  padding: 0.5em;
  white-space: nowrap;
  flex-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  min-height: 2.5em;
  height: 2.5em;
  justify-content: flex-start;
  align-items: center;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell].ClickTable_center__fiUWp,
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=columnheader].ClickTable_center__fiUWp {
  text-align: center;
  justify-content: center;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell].ClickTable_end__IGBXP,
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=columnheader].ClickTable_end__IGBXP {
  text-align: right;
  justify-content: flex-end;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] .ClickTable_toggleDetails__zcXQY,
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=columnheader] .ClickTable_toggleDetails__zcXQY {
  background: none;
  border: none;
  color: var(--foreground-color-2);
  text-decoration: underline;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 1rem;
  font-weight: 900;
  text-align: left;
  cursor: pointer;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] .ClickTable_toggleDetails__zcXQY:hover,
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=columnheader] .ClickTable_toggleDetails__zcXQY:hover {
  text-shadow: 1px 1px 2px var(--foreground-color-1-alpha);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] .ClickTable_toggleDetails__zcXQY:active,
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=columnheader] .ClickTable_toggleDetails__zcXQY:active {
  transform: scale(0.95);
  transition: transform 0.3s;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=columnheader] {
  background: var(--foreground-color-1);
  color: var(--background-color-1);
  font-weight: var(--bold);
  justify-content: flex-end;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] {
  display: flex;
  align-items: center;
  background: var(--background-color-1);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] > span, .ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] > a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell].ClickTable_pressed__No4oW {
  border-bottom: 1px solid transparent;
  border-right: 1px solid var(--lightgray);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] a {
  color: var(--foreground-color-2);
  text-decoration: underline;
  font-weight: var(--bold);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell]:focus,
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] *:focus {
  outline: none;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell]:focus.focus-visible::before,
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] *:focus.focus-visible::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border: 2px solid var(--foreground-color-2);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell]:focus.focus-visible:first-of-type::before,
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo > *[role=rowgroup] > *[role=row] [role=gridcell] *:focus.focus-visible:first-of-type::before {
  z-index: 1;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo .ClickTable_detailRow__iJHEm {
  padding: 0;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo .ClickTable_detailRow__iJHEm > * {
  padding: 0.5em;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo .ClickTable_detailRow__iJHEm:not(.ClickTable_expanded__y\\+lW3) {
  transition: max-height var(--heightTransitionBackward) ease-out;
  max-height: 0;
  overflow: hidden;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo .ClickTable_detailRow__iJHEm:not(.ClickTable_expanded__y\\+lW3):not(:last-of-type) {
  border-bottom: 1px solid transparent;
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo .ClickTable_detailRow__iJHEm:not(:last-of-type) {
  box-shadow: inset 0em -0.25em 0.25em -0.25em var(--foreground-color-1-alpha);
  border-bottom: 1px solid var(--lightgray);
}
.ClickTable_wrap__N06Wr .ClickTable_table__kB1Bo .ClickTable_detailRow__iJHEm.ClickTable_expanded__y\\+lW3 {
  transition: max-height var(--heightTransitionForward) ease-in;
  max-height: 1000px;
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 0;
  bottom: 0;
  transition: box-shadow 0.3s;
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ.ClickTable_hasScrollLeft__z6bc0 {
  box-shadow: 1px 0 5px var(--foreground-color-1-alpha);
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=row]:not(:last-of-type) [role=gridcell] {
  border-bottom: 1px solid var(--lightgray);
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=row]:not(:last-of-type) [role=gridcell].ClickTable_pressed__No4oW {
  border-bottom: 1px solid transparent;
  border-right: 1px solid var(--lightgray);
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=rowgroup]:last-of-type {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background: var(--background-color-1);
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=gridcell],
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=columnheader] {
  min-height: 2.5em;
  max-height: 2.5em;
  height: 2.5em;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=columnheader] {
  background: var(--foreground-color-1);
  color: var(--background-color-1);
  font-weight: var(--bold);
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=gridcell] {
  display: flex;
  background: var(--background-color-1);
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=gridcell] > span, .ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=gridcell] > a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ [role=gridcell] a {
  color: var(--foreground-color-2);
  text-decoration: underline;
  font-weight: var(--bold);
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ .ClickTable_fakeRow__QUZDI {
  border-bottom: 1px solid transparent;
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ .ClickTable_fakeRow__QUZDI:not(.ClickTable_expanded__y\\+lW3) {
  max-height: 0px;
  transition: max-height var(--heightTransitionBackward) ease-out;
}
.ClickTable_wrap__N06Wr .ClickTable_firstColumn__gq5zZ .ClickTable_fakeRow__QUZDI.ClickTable_expanded__y\\+lW3 {
  max-height: 1000px;
  transition: max-height var(--heightTransitionForward) ease-in;
}`, "",{"version":3,"sources":["webpack://./src/components/ClickTable/ClickTable.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,gCAAA;EACA,qBAAA;EACA,kBAAA;EACA,kCAAA;EACA,qCAAA;EACA,uDAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEE;EACE,eAAA;EACA,WAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAAJ;AAEI;EACE,cAAA;EACA,uBAAA;AAAN;AAIE;EACE,OAAA;EACA,QAAA;EACA,UAAA;AAFJ;AAKE;EACE,2CAAA;EACA,oBAAA;EACA,WAAA;AAHJ;AAME;EACE,WAAA;AAJJ;AAMI;EACE,qCAAA;AAJN;AAOI;EACE,aAAA;AALN;AAQQ;EACE,yCAAA;AANV;AAQU;EACE,oCAAA;EACA,wCAAA;AANZ;AAWM;;EAEE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AATR;AAWQ;;EACE,kBAAA;EACA,uBAAA;AARV;AAWQ;;EACE,iBAAA;EACA,yBAAA;AARV;AAWQ;;EACE,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,0BAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AARV;AAUU;;EACE,wDAAA;AAPZ;AAUU;;EACE,sBAAA;EACA,0BAAA;AAPZ;AAYM;EACE,qCAAA;EACA,gCAAA;EACA,wBAAA;EACA,yBAAA;AAVR;AAaM;EACE,aAAA;EACA,mBAAA;EACA,qCAAA;AAXR;AAYQ;EAEE,gBAAA;EACA,mBAAA;EACA,uBAAA;AAXV;AAcQ;EACE,oCAAA;EACA,wCAAA;AAZV;AAeQ;EACE,gCAAA;EACA,0BAAA;EACA,wBAAA;AAbV;AAgBQ;;EAEE,aAAA;AAdV;AAiBY;;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,2CAAA;AAdd;AAkBc;;EACE,UAAA;AAfhB;AAuBI;EACE,UAAA;AArBN;AAuBM;EACE,cAAA;AArBR;AAwBM;EACE,+DAAA;EACA,aAAA;EACA,gBAAA;AAtBR;AAwBQ;EACE,oCAAA;AAtBV;AA0BM;EACE,4EAAA;EAEA,yCAAA;AAzBR;AA4BM;EACE,6DAAA;EACA,kBAAA;AA1BR;AA8BE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;AA5BJ;AA8BI;EACE,qDAAA;AA5BN;AAgCM;EACE,yCAAA;AA9BR;AAgCQ;EACE,oCAAA;EACA,wCAAA;AA9BV;AAmCI;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,qCAAA;AAjCN;AAoCI;;EAEE,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAlCN;AAoCI;EACE,qCAAA;EACA,gCAAA;EACA,wBAAA;AAlCN;AAoCI;EACE,aAAA;EACA,qCAAA;AAlCN;AAmCM;EAEE,gBAAA;EACA,mBAAA;EACA,uBAAA;AAlCR;AAoCM;EACE,gCAAA;EACA,0BAAA;EACA,wBAAA;AAlCR;AAsCI;EACE,oCAAA;AApCN;AAsCM;EACE,eAAA;EACA,+DAAA;AApCR;AAuCM;EACE,kBAAA;EACA,6DAAA;AArCR","sourcesContent":[".wrap {\n  --heightTransitionForward: 1s;\n  --heightTransitionBackward: 0.5s;\n  --borderRadius: 0.5em;\n  position: relative;\n  border-radius: var(--borderRadius);\n  background: var(--foreground-color-1);\n  box-shadow: 1px 1px 5px var(--foreground-color-1-alpha);\n\n  .log {\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    clip: rect(0 0 0 0);\n    overflow: hidden;\n    white-space: nowrap;\n  }\n\n  .staticRow {\n    min-height: 5em;\n    width: 100%;\n    background: var(--background-color-1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5em;\n\n    .loadingIcon {\n      font-size: 2em;\n      color: var(--lightblue);\n    }\n  }\n\n  .scrollbarTrack {\n    left: 0;\n    right: 0;\n    z-index: 1;\n  }\n\n  .scrollbarThumb {\n    background: var(--foreground-color-1-alpha);\n    border-radius: 100px;\n    top: -0.5em;\n  }\n\n  .table {\n    width: 100%;\n\n    > *[role=\"rowgroup\"]:last-of-type {\n      background: var(--background-color-1);\n    }\n\n    > *[role=\"rowgroup\"] > *[role=\"row\"] {\n      display: flex;\n\n      &:not(:last-of-type) {\n        [role=\"gridcell\"] {\n          border-bottom: 1px solid var(--lightgray);\n\n          &.pressed {\n            border-bottom: 1px solid transparent;\n            border-right: 1px solid var(--lightgray);\n          }\n        }\n      }\n\n      [role=\"gridcell\"],\n      [role=\"columnheader\"] {\n        position: relative;\n        padding: 0.5em;\n        white-space: nowrap;\n        flex-wrap: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        flex-grow: 1;\n        min-height: 2.5em;\n        height: 2.5em;\n        justify-content: flex-start;\n        align-items: center;\n\n        &.center {\n          text-align: center;\n          justify-content: center;\n        }\n\n        &.end {\n          text-align: right;\n          justify-content: flex-end;\n        }\n\n        .toggleDetails {\n          background: none;\n          border: none;\n          color: var(--foreground-color-2);\n          text-decoration: underline;\n          width: 100%;\n          overflow: hidden;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          font-size: 1rem;\n          font-weight: 900;\n          text-align: left;\n          cursor: pointer;\n\n          &:hover {\n            text-shadow: 1px 1px 2px var(--foreground-color-1-alpha);\n          }\n\n          &:active {\n            transform: scale(0.95);\n            transition: transform 0.3s;\n          }\n        }\n      }\n\n      [role=\"columnheader\"] {\n        background: var(--foreground-color-1);\n        color: var(--background-color-1);\n        font-weight: var(--bold);\n        justify-content: flex-end;\n      }\n\n      [role=\"gridcell\"] {\n        display: flex;\n        align-items: center;\n        background: var(--background-color-1);\n        > span,\n        & > a {\n          overflow: hidden;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n        }\n\n        &.pressed {\n          border-bottom: 1px solid transparent;\n          border-right: 1px solid var(--lightgray);\n        }\n\n        a {\n          color: var(--foreground-color-2);\n          text-decoration: underline;\n          font-weight: var(--bold);\n        }\n\n        &:focus,\n        *:focus {\n          outline: none;\n\n          &:global(.focus-visible) {\n            &::before {\n              content: \"\";\n              position: absolute;\n              top: 0;\n              right: 0;\n              left: 0;\n              bottom: 0;\n              border: 2px solid var(--foreground-color-2);\n            }\n\n            &:first-of-type {\n              &::before {\n                z-index: 1;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .detailRow {\n      padding: 0;\n\n      & > * {\n        padding: 0.5em;\n      }\n\n      &:not(.expanded) {\n        transition: max-height var(--heightTransitionBackward) ease-out;\n        max-height: 0;\n        overflow: hidden;\n\n        &:not(:last-of-type) {\n          border-bottom: 1px solid transparent;\n        }\n      }\n\n      &:not(:last-of-type) {\n        box-shadow: inset 0em -0.25em 0.25em -0.25em\n          var(--foreground-color-1-alpha);\n        border-bottom: 1px solid var(--lightgray);\n      }\n\n      &.expanded {\n        transition: max-height var(--heightTransitionForward) ease-in;\n        max-height: 1000px;\n      }\n    }\n  }\n  .firstColumn {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    top: 0;\n    bottom: 0;\n    transition: box-shadow 0.3s;\n\n    &.hasScrollLeft {\n      box-shadow: 1px 0 5px var(--foreground-color-1-alpha);\n    }\n\n    [role=\"row\"]:not(:last-of-type) {\n      [role=\"gridcell\"] {\n        border-bottom: 1px solid var(--lightgray);\n\n        &.pressed {\n          border-bottom: 1px solid transparent;\n          border-right: 1px solid var(--lightgray);\n        }\n      }\n    }\n\n    [role=\"rowgroup\"]:last-of-type {\n      display: flex;\n      flex-grow: 1;\n      flex-direction: column;\n      background: var(--background-color-1);\n    }\n\n    [role=\"gridcell\"],\n    [role=\"columnheader\"] {\n      min-height: 2.5em;\n      max-height: 2.5em;\n      height: 2.5em;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      padding-left: 0.5rem;\n    }\n    [role=\"columnheader\"] {\n      background: var(--foreground-color-1);\n      color: var(--background-color-1);\n      font-weight: var(--bold);\n    }\n    [role=\"gridcell\"] {\n      display: flex;\n      background: var(--background-color-1);\n      > span,\n      & > a {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n      a {\n        color: var(--foreground-color-2);\n        text-decoration: underline;\n        font-weight: var(--bold);\n      }\n    }\n\n    .fakeRow {\n      border-bottom: 1px solid transparent;\n\n      &:not(.expanded) {\n        max-height: 0px;\n        transition: max-height var(--heightTransitionBackward) ease-out;\n      }\n\n      &.expanded {\n        max-height: 1000px;\n        transition: max-height var(--heightTransitionForward) ease-in;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ClickTable_wrap__N06Wr`,
	"log": `ClickTable_log__W+AMo`,
	"staticRow": `ClickTable_staticRow__L+O0r`,
	"loadingIcon": `ClickTable_loadingIcon__i50MF`,
	"scrollbarTrack": `ClickTable_scrollbarTrack__shH-1`,
	"scrollbarThumb": `ClickTable_scrollbarThumb__nhUye`,
	"table": `ClickTable_table__kB1Bo`,
	"pressed": `ClickTable_pressed__No4oW`,
	"center": `ClickTable_center__fiUWp`,
	"end": `ClickTable_end__IGBXP`,
	"toggleDetails": `ClickTable_toggleDetails__zcXQY`,
	"detailRow": `ClickTable_detailRow__iJHEm`,
	"expanded": `ClickTable_expanded__y+lW3`,
	"firstColumn": `ClickTable_firstColumn__gq5zZ`,
	"hasScrollLeft": `ClickTable_hasScrollLeft__z6bc0`,
	"fakeRow": `ClickTable_fakeRow__QUZDI`
};
export default ___CSS_LOADER_EXPORT___;
